export default __webpack_public_path__ + "static/media/Avatar-18.7c6c9288.svg";